export const CollectionColumn = [
    {
        id: "name",
        label: "Name",
        style: { custom: { width: "calc(100% - 54px)" } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "count",
        label: "Assets Count",
        style: { custom: { width: 54 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

export default CollectionColumn;
